import * as Sentry from '@sentry/react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './index.css';
import App from './App';
import Landing from './pages/Landing';
import Registro from './pages/Registro';
import RecuperarPassword from './pages/RecuperarPassword';
import NuevaPassword from './pages/NuevaPassword';
import InfoContacto from './pages/InfoContacto';
import Terminos from './pages/Terminos';
import Privacidad from './pages/Privacidad';
import reportWebVitals from './reportWebVitals';

Sentry.init({
  dsn: 'https://93cbc2daba6f65e85385380c03ac3c10@o4511077027086336.ingest.us.sentry.io/4511077029183488',
  environment: process.env.NODE_ENV,
  tracesSampleRate: 0.1,
  sendDefaultPii: false,
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/"                    element={<Navigate to="/info-contacto" replace />} />
        <Route path="/registro"            element={<Registro />} />
        <Route path="/recuperar-password"  element={<RecuperarPassword />} />
        <Route path="/nueva-password"      element={<NuevaPassword />} />
        <Route path="/info-contacto"        element={<InfoContacto />} />
        <Route path="/terminos"            element={<Terminos />} />
        <Route path="/privacidad"          element={<Privacidad />} />
        <Route path="/app"                 element={<App />} />
        <Route path="/app/:section"        element={<App />} />
        {/* Cualquier ruta desconocida → landing */}
        <Route path="*"                    element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
